import { v4 as uuidv4 } from "uuid";
export class AssetAssignmentModel {
    constructor() {
        this.id = uuidv4();
        this.assetId = "";
        this.employeeId = "";
    }
}
export default class AssetAssignment extends AssetAssignmentModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
